import { RouteConfig } from 'vue-router';

import Homepage from '~/views/Homepage';

const config: RouteConfig = {
  component: Homepage,
  path: '',
};

export default config;
